export const CREATE_POST = "CREATE_POST"
export const GET_POSTS = "GET_POSTS"
export const LIKE_POST = "LIKE_POST"
export const DISLIKE_POST = "DISLIKE_POST"
export const SAVE_POST = "SAVE_POST"
export const ERROR_POST = "ERROR_POST"
export const CLEAR_ERROR_POST = "CLEAR_ERROR_POST"
